var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", [_vm._v("Recetas")]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "b-nav",
        { staticClass: "w-25", attrs: { vertical: "", "align-h": "start" } },
        [
          _c("b-nav-item", { attrs: { active: "" } }, [
            _vm._v("Lista de recetas")
          ]),
          _vm._v(" "),
          _c("b-nav-item", [_vm._v("Nuevo informe")]),
          _vm._v(" "),
          _c("b-nav-item", [_vm._v("Nueva receta")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43e8e8f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43e8e8f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/professional/sideBar.vue
// module id = 3896
// module chunks = 30